import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {

  constructor(
    private userService: UserService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.redirectIfSingleCard();
  }

  private redirectIfSingleCard(): void {
    const visibleCards = this.getVisibleCardsWithRoutes();
    if (visibleCards.length === 1) {
      this.router.navigateByUrl(visibleCards[0].route);
    }
  }

  isCardVisible(feature: string): boolean {
    const customs = this.userService.getCurrentOrganization()?.customs;
    if (!customs) {
      return false;
    }
    const inFeatures = customs.features && feature in customs.features;
    const topLevelVal = customs[feature];
    if (inFeatures) {
      return customs.features[feature] === true;
    }
    if (feature in customs) {
      return topLevelVal !== false;
    }
    return false;
  }

  private getVisibleCardsWithRoutes(): { feature: string; route: string }[] {
    const cards: { feature: string; route: string }[] = [];

    if (this.isCardVisible('organization')) {
      const orgId = this.userService.getCurrentOrganization()?.id;
      if (orgId) {
        cards.push({ feature: 'organization', route: `/organization/${orgId}` });
      }
    }
    if (this.isCardVisible('frameworks')) {
      cards.push({ feature: 'frameworks', route: '/framework/all' });
    }
    if (this.isCardVisible('projects')) {
      cards.push({ feature: 'projects', route: this.getDecisionRoute() });
    }
    if (this.isCardVisible('academy')) {
      cards.push({ feature: 'academy', route: '/profile' });
    }

    return cards;
  }

  public getUserService() {
    return this.userService;
  }

  public getDecisionRoute() {
    return this.userService.currentOrganizationHasFeature('projects') ? '/projects' : '/decision/all';
  }

  get customs() {
    return this.userService?.getCurrentOrganizationUser()?.customs
  }
}
